export default () => {
  return {
    enter: (element, done) => {
      $("body, html").animate({ scrollTop: element.offset().top - 70 }, 1000, done);
    },
  };
};
